<template>
  <nd-dialog
    v-model="visible"
    close-btn
    :footer="false"
  >
    <div class="dialog-box">
      <div class="box-logo">
        <img src="./images/logo_jishujie@2x.png" class="logo">
        <div class="logo-text">天美贷官方小程序</div>
      </div>
      <div class="title">请使用微信小程序进入天美贷</div>
      <div class="sub-title">立领<span class="text-primary">50000</span>元提现额度</div>
      <img src="./images/img_a@2x.png">
      <nd-button
        @click="copyUrlLink"
        class="copy-btn"
        data-sensors-click
      >复制链接到浏览器打开
      </nd-button>
    </div>
  </nd-dialog>
</template>

<script>
import axios from '@/assets/axios'
import { copyToClipbord } from '@/assets/utils'
import { setKey, getKey } from '../../assets/utils'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      wxmpLink: ''
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.getShareLink()
      }
    }
  },
  methods: {
    copyUrlLink () {
      copyToClipbord(this.wxmpLink)
      this.$message('链接已复制，通过浏览器打开', 2000)
    },
    async getShareLink () {
      const { data } = await axios.request({
        url: '/wechat/miniApp/share',
        method: 'POST',
        data: {
          shareType: 'LINK'
      } })
      if (data.success) {
        this.wxmpLink = data.data.data
        const codeNo = data.data.codeNo
        const expTime = data.data.expTime
        this.recordSensorsData(codeNo, expTime)
      }
    },
    recordSensorsData (codeNo, expTime) {
      const storedCodeNo = getKey('qrCodeNo')
      const storedExpTime = getKey('qrCodeNoExpTime')
      // 获取当前时间戳
      const nowTime = new Date().getTime()
      // 如果当前时间戳大于存储的时间戳，说明已经过期
      if (!storedCodeNo || !storedExpTime || storedExpTime < nowTime) {
        // 记录新的codeNo和expTime
        setKey('qrCodeNo', codeNo)
        setKey('qrCodeNoExpTime', expTime)
        this.$sensors.track('PopupDisplay', { msg_name: '小程序引导弹窗', caseid: 'mini_pro', page_status: codeNo })
      } else {
        // 未过期
        this.$sensors.track('PopupDisplay', { msg_name: '小程序引导弹窗', caseid: 'mini_pro', page_status: storedCodeNo })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.dialog-box {
  text-align: center;
  padding: 0 38px 40px;
  text-align: center;
  .box-logo {
    display: flex;
    flex-direction: row;
    .logo {
      width: 40px;
      height: 40px;
    }
    .logo-text {
      font-size: 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 37px;
      margin-left: 8px;
    }
  }
  .title {
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    margin-top: 55px;
  }
  .sub-title {
    font-size: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    margin-bottom: 34px;
    .text-primary {
      color: #FF4633
    }
  }
  .copy-btn {
    width: 460px;
    height: 80px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FF4633;
    line-height: 80px;
    background: #fff;
    border: 2px solid #FF4633;
    margin: 0 auto;
    margin-top: 36px;
  }
}
</style>